import React, { useState, useEffect } from 'react';
import { ComponentBootstrap, withReactBootstrap } from '@demant/react-bootstrap';
import introBanner from '@demant/react-bootstrap/lib/schemas/intro-banner';
import VideoBanner from './js/VideoBanner';
var c = new ComponentBootstrap('.intro-banner.play-in-frame');
c.schemaData = introBanner;
c.reactApp = withReactBootstrap(VideoBanner);
c.run();